<template>
  <el-card>
    <page-main
      ref="tree"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
    >
      <page-header ref="header" slot="header" @query="getData" />
    </page-main>
  </el-card>
</template>

<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
export default {
  components: {
    PageHeader,
    PageMain
  },
  mixins: [BaseTable],
  data() {
    return {
      usePage: true,
      editFormDialogOptions: {
        visible: false,
        code: ''
      }
    }
  },
  mounted() {
    this.$eventBus.$on('selectTreeList', () => {
      this.$refs.header.query()
    })
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .materialCategoryTreeApi({
          ...form,
          ...this.page
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
          this.$nextTick(() => {
            this.$refs.tree.expandTree()
          })
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>
